import React from 'react'
import { Button, FormControlLabel, Grid, Switch, TextField, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'

// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import UserServices from '../../../../Services/Consumers/UserServices'
import { filterData } from '../../../../utils/helpers'
import { UserCompaniesFiltersPayload } from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import { NamedRoutes } from '../../../../routes'
import BreadCrumb from '../../BreadCrumb'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'

let { User_Config } = Configuration
export default function UserCompaniesContent ({ uid, handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userCompaniesLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  let NumbersRegex = /^[0-9]+$/
  let isFilterValid = {
    tax_id: true
  }
  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        display: 'false',
        viewColumns: false,
        filter: false
      }
    },
    {
      name: 'taxpayer_name',
      label: intl.formatMessage({ id: 'CompanyHeader.TaxpayerName' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.TaxpayerName'/>:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'tax_id',
      label: intl.formatMessage({ id: 'CompanyHeader.UniqueTaxId' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.UniqueTaxId'/>:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'CompanyHeader.UniqueTaxId' })}
              id='tax_id'
              name='tax_id'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.tax_id = !(event.target.value && ((event.target.value.length < 9 || event.target.value.length > 10) || !NumbersRegex.test(event.target.value)))
              }}
              helperText={filterList[index][0] &&
              (!NumbersRegex.test(filterList[index][0]) ? intl.formatMessage({ id: 'validationSchema.taxOnlyNumbers' })
                : (((filterList[index][0]).length < 9 || (filterList[index][0]).length > 10) && intl.formatMessage({ id: 'validationSchema.taxLengthMinMax' })))}
              error={(filterList[index][0] && (!NumbersRegex.test(filterList[index][0]) || ((filterList[index][0]).length < 9 || (filterList[index][0]).length > 10)))}
            />
          )
        }
      }
    },
    {
      name: 'name',
      label: intl.formatMessage({ id: 'CompanyHeader.CompanyName' }),
      options: {
        filterType: 'textField',
        display: 'false',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.CompanyName'/>:
                <span>{v[0]}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'role',
      label: intl.formatMessage({ id: 'CompanyHeader.UserRole' }),
      options: {
        // filterType: 'dropdown'و
        filterOptions: {
          names: ['owner', 'delegate'],
          renderValue: v => (v === 'delegate') ? intl.formatMessage({ id: 'CompanyData.UserRole.delegate' }) : intl.formatMessage({ id: 'CompanyData.UserRole.owner' })
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.UserRole'/>:
                <span>{(v === 'delegate') ? intl.formatMessage({ id: 'CompanyData.UserRole.delegate' }) : intl.formatMessage({ id: 'CompanyData.UserRole.owner' })}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'subscription_end_date',
      label: intl.formatMessage({ id: 'CompanyHeader.subscriptionEndDate' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY h:mm a">{data[dataIndex].subscription_end_date}</Moment>
        }
      }
    },
    {
      name: 'active',
      label: intl.formatMessage({ id: 'CompanyHeader.UserStatus' }),
      options: {
        filterOptions: {
          names: [0, 1],
          renderValue: v => !!v ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.UserStatus'/>:
                <span>{!!v ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })}</span>
              </div>
            )
          }
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            !!tableMeta && tableMeta.rowData[0] &&
            <FormControlLabel
              label={value ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })}
              value={value ? true : false}
              control={
                <Switch color="primary" checked={value} value={value ? true : false}/>
              }
              onChange={(event) => {
                updateValue(!JSON.parse(event.target.value))
                activateDeactivateUserCompany(tableMeta.rowData[0], !JSON.parse(event.target.value), updateValue)
              }}
            />
          )
        }
      }
    }
  ]
  const updateLoadedData = (cId, newActiveValue) => {
    let newData = loadedData
    newData.forEach((pageData) => {
      pageData.forEach((company) => {
        if (cId === company.id) {
          company.active = !!newActiveValue ? 1 : 0
        }
      })
    })
    setLoadedData(newData)
  }

  const activateDeactivateUserCompany = (cId, newActiveValue, updateValue) => {
    if (!!keycloak?.authenticated) {
      UserServices.activateDeactivateUserCompany(uid, cId, { 'active': newActiveValue }, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, setIsLoading).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
          updateValue(!newActiveValue)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: newActiveValue ? 'Users.List.Table.Activate.Success' : 'Users.List.Table.Deactivate.Success' }),
              color: 'success'
            }, 'success')
            updateLoadedData(cId, newActiveValue)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
            updateValue(!newActiveValue)
          }
        }

      })

    }
  }
// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {
      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        UserServices.getUserCompanies(uid, {
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UserCompaniesFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
            // setUserCompaniesFailure(true)
          } else {
            if (!!result && !!result.data && !!result.data.data) {
              let newData = []
              result.data.data.forEach((company) => {
                newData.push({
                  id: company.company.id,
                  taxpayer_name: company.company.taxpayer_name,
                  tax_id: company.company.tax_id,
                  name: company.company.name,
                  role: company.role,
                  subscription_end_date: company.company.subscription_end_date,
                  active: company.active
                })
              })
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    },// eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('active' === columns[index].name) {
          filters[columns[index].name] = !!filterItem[0] ? 1 : 0
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }
  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, {}, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    downloadOptions: {
      filename: `${intl.formatMessage({ id: 'DashboardContent.BreadCrumb.companies' })}.csv`,
      separator: ','
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button disabled={!(isFilterValid.tax_id)} color='primary' variant="contained"
                  onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && typeof type === 'string' && type === 'custom'
          && (column === 'tax_id'))) {
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Companies.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Users.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Users'/>,
          link: NamedRoutes.workspace.user.list
        }
      ]} current={<FormattedMessage id='UserMenu.dashboard'/>}/>
      <PageTitle title={<FormattedMessage id='DashboardContent.BreadCrumb.companies'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true}/>}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='UserMenu.dashboard'/>
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
